export default () => parseInt(Math.random() * 1000000)